import { render, staticRenderFns } from "./NoRealTaskResourceReportDialog2.vue?vue&type=template&id=b46cfe12&scoped=true&"
import script from "./NoRealTaskResourceReportDialog2.vue?vue&type=script&lang=js&"
export * from "./NoRealTaskResourceReportDialog2.vue?vue&type=script&lang=js&"
import style0 from "./NoRealTaskResourceReportDialog2.vue?vue&type=style&index=0&id=b46cfe12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46cfe12",
  null
  
)

export default component.exports